import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { Heading, Tag } from 'components/common/Elements/Elements.js';
import { featuresFormater } from 'utils/featuresFormater';

import classes from './Tags.module.scss';

const Tags = ({ features = [], close }) => {
  const { t } = useTranslation(['activity']);

  return (
    <>
      {features.length > 0 && features[0] !== '' && (
        <section className={classes.tags_wrap}>
          <Heading className={classes.tags_header}>
            {t('activity:features.SELECTED_FEATURES')}
          </Heading>
          <div className={classes.tags}>
            {features.map(item => (
              <Tag
                tag={featuresFormater(item, t)}
                onClick={close(item)}
                aria-label={`${t(
                  'activity:features.SELECTED_FEATURES'
                )} ${featuresFormater(item, t)}`}
                key={item}
              />
            ))}
          </div>
        </section>
      )}
    </>
  );
};

Tags.propTypes = {
  features: PropTypes.arrayOf(PropTypes.string),
  close: PropTypes.func.isRequired
};

export default Tags;
